import { Component, OnInit } from "@angular/core";

@Component({
  selector: "mandae-get-data",
  templateUrl: "./get-data.component.html",
})
export class GetDataComponent implements OnInit {
  constructor() {}

  ngOnInit() {
    console.log("invoked");
  }
}
